var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstelasAmc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 172,
    viewBox: "0 0 66 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 65.1004H0.877686V61.7631H39.982V65.1004Z",
    fill: "#FA0073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 50.0775H0.877686V46.7403H39.982V50.0775Z",
    fill: "#FA0073"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 35.0525H0.877686V31.7153H39.982V35.0525Z",
    fill: "#FA0073"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 20.0298H0.877686V16.6926H39.982V20.0298Z",
    fill: "#FA0073"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 5.00482H0.877686V1.66749H39.982V5.00482Z",
    fill: "#FA0073"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 66.7701H34.8413V60.0975H66.5114V66.7701Z",
    fill: "#FA0073"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 51.7452H34.8413V45.0727H66.5114V51.7452Z",
    fill: "#FA0073"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 36.7202H34.8413V30.0478H66.5114V36.7202Z",
    fill: "#FA0073"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8444 21.6979V15.0254L66.5124 15.0233L66.5144 21.6958L34.8444 21.6979Z",
    fill: "#FA0073"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 6.67255H34.8413V1.04904e-05H66.5114V6.67255Z",
    fill: "#FA0073"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 170.33H0.877686V166.993H39.982V170.33Z",
    fill: "#FA0073"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 155.308H0.877686V151.97H39.982V155.308Z",
    fill: "#FA0073"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.877686 140.285V136.948L39.982 136.946V140.283L0.877686 140.285Z",
    fill: "#FA0073"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 125.26H0.877686V121.922H39.982V125.26Z",
    fill: "#FA0073"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 110.235H0.877686V106.898H39.982V110.235Z",
    fill: "#FA0073"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 95.21H0.877686V91.8726H39.982V95.21Z",
    fill: "#FA0073"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 80.185H0.877686V76.8478H39.982V80.185Z",
    fill: "#FA0073"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.877686 49.7794V46.4421L39.982 46.4401V49.7774L0.877686 49.7794Z",
    fill: "#FA0073"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 172H34.8413V165.328H66.5114V172Z",
    fill: "#FA0073"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 156.975H34.8413V150.303H66.5114V156.975Z",
    fill: "#FA0073"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 141.95H34.8413V135.278H66.5114V141.95Z",
    fill: "#FA0073"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 126.925H34.8413V120.253H66.5114V126.925Z",
    fill: "#FA0073"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 111.902H34.8413V105.23H66.5114V111.902Z",
    fill: "#FA0073"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9478 96.1125H35.2777V89.44H66.9478V96.1125Z",
    fill: "#FA0073"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 81.8546H34.8413V75.1821H66.5114V81.8546Z",
    fill: "#FA0073"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 51.8048H34.8413V45.1323H66.5114V51.8048Z",
    fill: "#FA0073"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 36.7821H34.8413V30.1096H66.5114V36.7821Z",
    fill: "#FA0073"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5114 21.7571H34.8413V15.0847H66.5114V21.7571Z",
    fill: "#FA0073"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.982 65.1622H0.877686V61.825H39.982V65.1622Z",
    fill: "#FA0073"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8444 66.8307V60.1583L66.5124 60.1562L66.5144 66.8287L34.8444 66.8307Z",
    fill: "#FA0073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstelasAmc);
export default __webpack_public_path__ + "static/media/Estelas_AMC.9fbbbfd69d371ebb157a2aa3ed27324c.svg";
export { ForwardRef as ReactComponent };